export const ACTION_RESET = 'FETCH_RMIPARTICLES_RESET';
export const ACTION_REQUEST = 'FETCH_RMIPARTICLES_REQUEST';
export const ACTION_SUCCESS = 'FETCH_RMIPARTICLES_SUCCESS';
export const ACTION_ERROR = 'FETCH_RMIPARTICLES_ERROR';
